// extracted by mini-css-extract-plugin
module.exports = {"burger_ingredients_list":"burger-ingredients-category_burger_ingredients_list__3k6bD"};